import MainContainer from "@/components/MainContainer/MainContainer";
import { NAVIGATION_ITEMS } from "@/shared";

import RestrictedRoute from "./RestrictedRoute";

interface PageWrapperRouteProps {
  itemName: NAVIGATION_ITEMS;
  Component: React.ComponentType;
}

const PageWrapperRoute = ({ itemName, Component }: PageWrapperRouteProps) => (
  <MainContainer>
    <RestrictedRoute itemName={itemName}>
      <Component />
    </RestrictedRoute>
  </MainContainer>
);

export default PageWrapperRoute;
